import { Component, AfterViewInit, OnInit } from '@angular/core';

@Component({
    selector: 'app-tnc',
    templateUrl: 'tnc.component.html',
    styleUrls: ['tnc.component.css'],
    standalone: false
})
export class TncComponent implements OnInit,AfterViewInit {
    message: any;
    constructor() { }

    ngOnInit() {
    }
    ngAfterViewInit(): void {
        let el = document.querySelector('.toptoscroll');
        el.scrollIntoView({behavior:"smooth"});
        //window.scrollTo(20, document.body.scrollHeight || document.documentElement.scrollHeight);
    }
}  